import { RootState } from '../../store';

export const selectDaySlotsRecalculating = (state: RootState, dateString: string): boolean => (
  state.global.slotsCalculationDays.includes(dateString)
);
